import React, { SFC } from "react";
import withContentWrap, { PropsType as WithContentWrapProps } from "../../hoc/withContentWrap";
import withVerticalSpacing, { PropsType as WithVerticalSpacingProps } from "../../hoc/withVerticalSpacing";
import "./style.scss";

type PropsType = WithContentWrapProps &
    HTMLProps<HTMLDivElement> &
    WithVerticalSpacingProps & {
        size?: "default" | "small" | "medium" | "large";
    };

const Cards = (props): SFC => {
    return <div className="Cards">{props.children}</div>;
};

export default withVerticalSpacing(withContentWrap(Cards));
